import type { MapBounds } from '$lib/utils/definitions';

export const defaultPagination = {
  page: 1,
  pageSize: 24,
};

// Paris coordinates
export const defaultCoords: { latitude: number; longitude: number } = {
  latitude: 46.227638,
  longitude: 2.213749,
};

export const parisCoords: { latitude: number; longitude: number } = {
  latitude: 48.5,
  longitude: 2.2,
};

export const defaultBounds: MapBounds = {
  northEastLat: 52.37559917665913,
  northEastLng: 12.524414062500002,
  southWestLat: 39.30029918615029,
  southWestLng: -8.085937500000002,
};

export const defaultRadius = 5;

export const defaultZoomDesktop = 6;
export const defaultZoomMobile = 5;

export const contactEmail = 'arthur.massonneau.ext@beta.gouv.fr';

export const defaultDepartementsCodesRecord: Record<string, number> = {
  '01': 0,
  '02': 0,
  '03': 0,
  '04': 0,
  '05': 0,
  '06': 0,
  '07': 0,
  '08': 0,
  '09': 0,
  '10': 0,
  '11': 0,
  '12': 0,
  '13': 0,
  '14': 0,
  '15': 0,
  '16': 0,
  '17': 0,
  '18': 0,
  '19': 0,
  '2A': 0,
  '2B': 0,
  '21': 0,
  '22': 0,
  '23': 0,
  '24': 0,
  '25': 0,
  '26': 0,
  '27': 0,
  '28': 0,
  '29': 0,
  '30': 0,
  '31': 0,
  '32': 0,
  '33': 0,
  '34': 0,
  '35': 0,
  '36': 0,
  '37': 0,
  '38': 0,
  '39': 0,
  '40': 0,
  '41': 0,
  '42': 0,
  '43': 0,
  '44': 0,
  '45': 0,
  '46': 0,
  '47': 0,
  '48': 0,
  '49': 0,
  '50': 0,
  '51': 0,
  '52': 0,
  '53': 0,
  '54': 0,
  '55': 0,
  '56': 0,
  '57': 0,
  '58': 0,
  '59': 0,
  '60': 0,
  '61': 0,
  '62': 0,
  '63': 0,
  '64': 0,
  '65': 0,
  '66': 0,
  '67': 0,
  '68': 0,
  '69': 0,
  '70': 0,
  '71': 0,
  '72': 0,
  '73': 0,
  '74': 0,
  '75': 0,
  '76': 0,
  '77': 0,
  '78': 0,
  '79': 0,
  '80': 0,
  '81': 0,
  '82': 0,
  '83': 0,
  '84': 0,
  '85': 0,
  '86': 0,
  '87': 0,
  '88': 0,
  '89': 0,
  '90': 0,
  '91': 0,
  '92': 0,
  '93': 0,
  '94': 0,
  '95': 0,
  '971': 0,
  '972': 0,
  '973': 0,
  '974': 0,
  '976': 0,
};

export const defaultRegionsCodesRecord: Record<string, number> = {
  ARA: 0,
  BFC: 0,
  BRE: 0,
  CVL: 0,
  GES: 0,
  HDF: 0,
  IDF: 0,
  NOR: 0,
  NAQ: 0,
  OCC: 0,
  PDL: 0,
  PAC: 0,
  '20R': 0,
  '971': 0,
  '972': 0,
  '973': 0,
  '974': 0,
  '976': 0,
};

export const regionCodesAcronymsMatching: Record<string, string> = {
  '84': 'ARA',
  '27': 'BFC',
  '53': 'BRE',
  '24': 'CVL',
  '44': 'GES',
  '32': 'HDF',
  '11': 'IDF',
  '28': 'NOR',
  '75': 'NAQ',
  '76': 'OCC',
  '52': 'PDL',
  '93': 'PAC',
  '94': '20R',
  '01': '971',
  '02': '972',
  '03': '973',
  '04': '974',
  '06': '976',
};
